import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "search": "",
        "sort": {
            "attributes": ["startDate"],
            "sorts": ["desc"]
        },
        "filters":[
            // "id","=",2402
        ],
        "pageNo": 1,
        "itemsPerPage": 10
    },
    certificateFilter:{
        "search": "",
        "sort": {
            "attributes": ["id"],
            "sorts": ["desc"]
        },
        "filters":[ 
        ] ,
        "pageNo": 1,
        "itemsPerPage": 10
    }
};

const trainingHistorySlice = createSlice({
    name: 'trainingHistory',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
        updateCertificateFilter: (state, action) => {
            state.certificateFilter = action.payload;
        }
    },
});

export const {
    updateFilter,
    updateReducer,
    updateCertificateFilter
} = trainingHistorySlice.actions;

export default trainingHistorySlice.reducer;